import { useState } from "react";

import { DraftId } from "../../draftId";

const LANDING_DRAFT_ID_STORAGE_KEY = "forge:new-thread-composer-draft-id:v1";

function readOrCreateLandingDraftId(): DraftId {
  if (typeof window === "undefined") return DraftId.make("landing-composer-draft");
  try {
    const existing = window.localStorage.getItem(LANDING_DRAFT_ID_STORAGE_KEY)?.trim();
    if (existing) return DraftId.make(existing);
    const created = crypto.randomUUID();
    window.localStorage.setItem(LANDING_DRAFT_ID_STORAGE_KEY, created);
    return DraftId.make(created);
  } catch {
    return DraftId.make("landing-composer-draft");
  }
}

/** A browser-stable local composer identity. It does not create a runtime draft session. */
export function useLandingComposerDraftId(): DraftId {
  return useState(readOrCreateLandingDraftId)[0];
}
